import React from 'react'
import { FieldError } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { NumericFormat } from 'react-number-format'

import { CurrencyEnum } from '../../../lib/graphql'
import { cn } from '../../../shadcn/utils'

type InputPriceProps = {
  className?: string
  disabled?: boolean
  currency?: CurrencyEnum
  value?: string | number
  onChange?: (value: string | number | undefined) => void
  error?: FieldError | undefined
}

const InputPrice = React.forwardRef<HTMLInputElement, InputPriceProps>(
  ({ disabled, currency, onChange, value, error, ...props }, ref) => {
    const intl = useIntl()
    return (
      <div className={cn('w-full', props.className)}>
        <NumericFormat
          displayType='input'
          decimalSeparator=','
          decimalScale={2}
          fixedDecimalScale
          suffix={currency === CurrencyEnum.EUR ? ' €' : ''}
          prefix={currency === CurrencyEnum.GBP ? '£ ' : ''}
          placeholder={`${disabled ? '-' : intl.formatMessage({ defaultMessage: 'Écrire ici', id: 'ui.InputPrice.writeHere' })}`}
          disabled={disabled}
          className={cn(
            'flex h-10 w-full rounded-md border border-grey-500 bg-transparent px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
            disabled ? 'bg-grey-300' : '',
            error ? 'border-red-500' : '',
            props.className,
          )}
          getInputRef={ref}
          onValueChange={({ value }) => {
            const formattedValue = value?.replace(',', '.')
            if (onChange) {
              onChange(formattedValue)
            }
          }}
          value={value}
          {...props}
        />
      </div>
    )
  },
)

export default InputPrice
